var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('report-data-provider',{attrs:{"requiredReports":_vm.requiredReports},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loading = ref.loading;
var error = ref.error;
var retry = ref.retry;
return [(loading)?_c('card-loading'):(error)?_c('card-reload',{on:{"reload":function($event){return retry()}}}):_c('average-card',{attrs:{"data":_vm.cardData}})]}}]),model:{value:(_vm.reports),callback:function ($$v) {_vm.reports=$$v},expression:"reports"}})}
var staticRenderFns = []

export { render, staticRenderFns }